var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconThumbsUp40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2285_8912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1172 32.7771H28.7403C29.9648 32.7771 30.9481 31.6557 31.7488 30.5186C34.7655 26.2349 35.4133 19.8321 35.4133 18.2353C35.4133 16.6386 34.198 16.0502 32.2299 16.0502H23.4596C24.4317 13.9672 25.7909 11.4824 25.7909 9.71949C25.7909 7.8109 25.0616 6.44043 23.4301 6.44043C21.7986 6.44043 21.3801 7.78621 20.796 9.09762C19.7201 11.5135 17.4497 16.9769 14.1172 16.9769V32.7771Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6875 33.5751H14.2645V15.2192H4.6875V33.5751Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.361 28.6381L10.3807 28.657C10.8881 29.1441 10.9045 29.9503 10.4174 30.4576C10.4054 30.4701 10.3932 30.4824 10.3807 30.4943L10.361 30.5132C9.83736 31.016 9.01029 31.016 8.48662 30.5132L8.46692 30.4943C7.95955 30.0072 7.94312 29.2011 8.43022 28.6937C8.4422 28.6812 8.45444 28.669 8.46692 28.657L8.48662 28.6381C9.01029 28.1353 9.83736 28.1353 10.361 28.6381Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2285_8912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconThumbsUp40);
export default __webpack_public_path__ + "static/media/pictogramBeaconThumbsUp40.4a7c93d35d4da55698bf6722eebec764.svg";
export { ForwardRef as ReactComponent };